// Define constants
export const constants = {
  DEFAULT_OPENAI_EMBEDDING_MODEL: 'text-embedding-3-large',
  OPENAI_API_URL: 'https://api.openai.com/v1/embeddings',
};
